export enum EAppMessages {
  DRAIVN_COPYRIGHT = "APP.DRAIVN_COPYRIGHT",
}
